export const LAB_REPORT_READY_SMS = ['whole_order', 'each_release'];
export const LAB_ACCESSION_MODES = ['per_test', 'per_tube'];
export const LAB_TUBE_SUFFIXES = ['letter', 'numeric'];
export const LAB_ANALYSER_OVERRIDE = ['technician', 'with_reason', 'with_approval', 'verifier_only'];
export const LAB_REPORT_LANGUAGES = ['en', 'ar', 'both'];
export const LAB_REJECTION_CODES = [
    'HAEMOLYSED',
    'CLOTTED',
    'QNS',
    'MISLABELLED',
    'UNLABELLED',
    'WRONG_CONTAINER',
    'CONTAMINATED',
    'DELAYED',
    'LEAKED',
];
export const LAB_REPRINT_REASONS = ['printer_jam', 'damaged_label', 'extra_tube', 'other'];
export const GULF_REPORT_COUNTRIES = ['SA', 'AE', 'QA'];
export const COLLECTION_IDENTIFIERS = ['mrn', 'national_id', 'dob', 'father_or_husband_name'];
const COLLECTION_IDENTIFIERS_BY_COUNTRY = {
    PK: ['mrn', 'national_id', 'father_or_husband_name'],
    GB: ['dob', 'mrn', 'national_id'],
    SA: ['national_id', 'dob'],
    AE: ['national_id', 'dob'],
    QA: ['national_id', 'dob'],
    CO: ['national_id', 'dob'],
};
export const COLLECTION_IDENTIFIER_LABELS = {
    mrn: 'MR number',
    national_id: 'national ID',
    dob: 'date of birth',
    father_or_husband_name: "father's or husband's name",
};
export function collectionIdentifiersFor(country) {
    return COLLECTION_IDENTIFIERS_BY_COUNTRY[(country ?? '').toUpperCase()] ?? ['mrn', 'dob', 'national_id'];
}
export const COLLECTION_IDENTITY_METHODS = ['wristband_scan', 'two_identifiers', 'override'];
//# sourceMappingURL=lab-settings.js.map